import React from 'react'
import { Button } from '~/lib/ui/button'
import { Input } from '~/lib/ui/input'
import { Label } from '~/lib/ui/label'
import { useTranslation } from '~/hooks/useTranslation'

const Toolbar = () => {
  const { t } = useTranslation('Toolbar')

  return (
    <div className="flex flex-col md:flex-row">
      <div className="flex-grow">
        <div className="flex flex-col">
          <div className="flex items-end gap-2">
            <div className="space-y-2">
              <Label htmlFor="recruiter_or_firm_name_search">
                {t('search')}
              </Label>
              <Input
                id="recruiter_or_firm_name_search"
                className={'md:w-96'}
                type="text"
              />
            </div>
            <Button>{t('search')}</Button>
          </div>
          <Button className="self-start p-0" variant="link">
            {t('clear_search')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Toolbar
